var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffroad3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 51,
    viewBox: "0 0 126 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 21.8953V22.6878C122 34.5731 110.572 43.1178 99.1718 39.7563L94.9696 38.5172C89.0583 36.7741 82.7291 37.1002 77.0283 39.4416L69.5528 42.5119C62.1626 45.5472 53.8691 45.5208 46.4984 42.4385L38.8108 39.2237C33.4452 36.9799 27.3467 37.323 22.2668 40.1545L10.7682 46.5635C7.28572 48.5046 3 45.9869 3 42V25.5C3 18.1983 7.76224 11.7504 14.7411 9.60309L33.217 3.9182C40.1296 1.79123 47.6483 3.86891 52.488 9.24345C58.9054 16.37 68.8816 19.1135 78.0407 16.2703L109.276 6.57431C116.764 4.24978 123.988 10.8417 122.356 18.511C122.119 19.6235 122 20.7578 122 21.8953Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffroad3);
export default __webpack_public_path__ + "static/media/offroad3.17bca6f3.svg";
export { ForwardRef as ReactComponent };